import layoutMain from '@/layout/main'
import mine from './apps/mine'
import system from './apps/system'
import analysis from './apps/analysis'
import dashboard from './apps/dashboard'
import test from './apps/test'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

/**
 * 在主框架内显示
 */
const frameIn = [{
		path: '/',
		redirect: {
			name: 'mine-generals'
		},
		component: layoutMain,
		children: [
			// 首页
			{
				path: 'index',
				name: 'index',
				component: _import('system/index'),
				meta
			},
			{
				path: 'public/:id',
				name: 'public-id',
				component: _import('system/index'),
				meta
			},
			// 系统 前端日志
			{
				path: 'log',
				name: 'log',
				component: _import('system/log'),
				meta
			},
			// 刷新页面 必须保留
			{
				path: 'refresh',
				name: 'refresh',
				hidden: true,
				component: _import('system/function/refresh'),
			},
			// 页面重定向 必须保留
			{
				path: 'redirect/:route*',
				name: 'redirect',
				hidden: true,
				component: _import('system/function/redirect')
			}
		]
	},
	mine,
	system,
	analysis,
	dashboard,
	test,
]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	},
	{ 
		path: '/share/component/:id', 
		name: 'share-component-id', 
		component: _import('shared/ViewComponent'), 
	},
	{
		path: '/share/dashboard/:id', 
		name: 'share-dashboard-id', 
		component: _import('shared/Dashboard'), 
	},
]

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
]
